<template>
  <div class="container-fluid footer1">
    <div class="row pt-4 pb-3 d-flex justify-content-center">
      <div class="mr-md-4">
        <img
          class="img-footer fr-c"
          src="./../assets/footer.webp"
          width="110"
          height="30"
          title="logo havoline"
          alt="logo havoline"
        />
      </div>
      <div class="mr-md-4 text-siguenos ">
        <a href="https://www.instagram.com/HavolineColombia" target="_blank">
          <img 
            height="35" 
            width="35" 
            src="./../assets/icon/logo_instagram.png" 
            title="Instagram HavolineColombia"
            alt="Instagram HavolineColombia"
          />
        </a>
        <a href="https://www.facebook.com/HavolineColombia" target="_blank">
          <img
            style="margin-left:10px"
            height="35"
            width="35"
            src="./../assets/icon/logo_facebook.png"
            title="Facebook HavolineColombia"
            alt="Facebook HavolineColombia"
          />
        </a>
        <a href="https://www.youtube.com/@ChevronColombia" target="_blank">
          <img
            style="margin-left:10px"
            height="35"
            width="35"
            src="./../assets/icon/logo_youtube.png"
            title="YouTube HavolineColombia"
            alt="YouTube HavolineColombia"
          />
        </a>
      </div>
    </div>
    <div
      class="row pb-4 justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
    >
      <div id="links" class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mx-auto">
        <p class="text-footer">
          Un producto de la empresa Chevron © 2021 Chevron Petroleum Company.
          Todos los derechos reservados. Todas las marcas son propiedad de
          Chevron Intellectual Property LLC.
        </p>
        <a :href="file.tyc.url" target="_blank" class="c1"
          ><label id="tyc">Términos y condiciones de actividades</label></a
        >
        <router-link :to="{ name: 'frequentQuestions' }"
          ><label class="c1 pc">Preguntas frecuentes</label></router-link
        >
        <a :href="file.tycF.url" target="_blank" class="c1 pc"
          ><label id="tyc_f">Términos y condiciones plataforma Havoline Moto Club</label></a
        >
        <a
          style="cursor: pointer"
          :href="file.hd.url"
          target="_blank"
          class="c1 pc"
          ><label id="pyp">Políticas de privacidad</label></a
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "footerLanding",
  data() {
    return {
      file: {
        tyc: {
          url: "",
        },
        tycF: {
          url: "",
        },
        hd: {
          url: "",
        },
      },
    };
  },

  // Datos estructurados
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "Havoline Motoclub",
            "url": "https://havolinemotoclub.com",
            "sameAs": [
              "https://www.facebook.com/HavolineColombia",
              "https://www.instagram.com/HavolineColombia",
              "https://www.youtube.com/@ChevronColombia"
            ]
          }
        }
      ]
    };
  },

  methods: {
    getDocuments() {
      axios
        .get("api/files/active/" + 1)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file.tyc = res.data.data[0];
            // console.log('this.file.tyc ', JSON.stringify(this.file.tyc));
          }
        })
        .catch((error) => {
          console.log(error);
        });

      axios
        .get("api/files/active/" + 2)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file.tycF = res.data.data[0];
            // console.log('this.file.tycF ', JSON.stringify(this.file.tycF));
          }
        })
        .catch((error) => {
          console.log(error);
        });

      axios
        .get("api/files/active/" + 3)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file.hd = res.data.data[0];
            // console.log('this.file.hd ', JSON.stringify(this.file.hd));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {},
  mounted() {
    this.getDocuments();
  },
};
</script>

<style>
.fl-c {
  float: left;
}

.fr-c {
  float: right !important;
}

.c1 {
  border-bottom: 1px solid !important;
  font-size: 13px;
  cursor: pointer !important;
}

.pc {
  margin-left: 40px;
}

.text-siguenos {
  color: #e9434c;
  font-size: 13px;
}

.text-footer {
  color: #2c2b2b !important;
  font-family: "ubuntu-italic";
  font-display: swap;
  font-size: 13px;
}

.footer1 {
  background-color: white !important;
  height: 70%;
}

.img-footer {
  /* text-align: left !important; */
  float: left;
}
#tyc, #tyc_f, #pyp{
  cursor: pointer !important;
}

/* 
  .icon-footer{
    float: right;
    color:#dc3545 !important;
  } */

@font-face {
  font-family: "ubuntu-italic";
  src: url("./../assets/font/Ubuntu-Italic.ttf");
  font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
  .img-footer {
    content: url("./../assets/LogoMenu.png");
  }

  .pc {
    margin-left: 20px;
  }

  .pb-a {
    padding-bottom: 20px;
  }

  .fl-c {
    float: none;
  }

  .fr-c {
    float: none !important;
  }
}
</style>
